/**
 * @file Custom prints configurations view from album purchase.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import CustomPrintConfiguratorContainer from '../../containers/purchase/custom-prints/CustomPrintConfiguratorContainer';
import CustomPrintsConfiguratorViewHeader from '../../apps/consumer/components/custom-prints/CustomPrintsConfiguratorViewHeader';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const PurchaseAlbumCustomPrintsView = ({ match }) => (
  <div className="wrapper-main content-wrap-gray">
    <CustomPrintsConfiguratorViewHeader album={{ id: match.params.albumId }} />

    <div className="custom-prints-view-wrap">
      <CustomPrintConfiguratorContainer />
    </div>
  </div>
);

PurchaseAlbumCustomPrintsView.propTypes = propTypes;

export default compose(withRouter)(PurchaseAlbumCustomPrintsView);
